import api from './client'

export const rolesApi = {
  listar:   ()              => api.get('/roles'),
  crear:    (data)          => api.post('/roles', data),
  editar:   (id, data)      => api.put(`/roles/${id}`, data),
  eliminar: (id)            => api.delete(`/roles/${id}`),
}
